export const headerEN = {
  menu: {
    home: "Home",
    product: "Product",
    ecosystem: "Ecosphere",
    about: "About Us",
    join: "Join Us",
    contact: "Contact Us",
    // 产品中心
    allIntelligence:
      "Simulation-based Various Intelligent Agents Testing & Validation Software System",
    PDGaiA:
      "Simulation-based Testing and Development Platform for Automated Driving - PDGaiA<sup>®</sup>7",
    PDRobot: "PD Robotics Virtual Development & Validation Solution",
    PDUranus: "PDUranus Virtual Optimization Platform for Intelligent UAVs",
    coreTechnology: "Core Technologies Boosting Efficient Data-based Iteration",
    OnCloud:
      "On Cloud Computing Platform for Precise Simulation - PD Cloud SiL",
    PDRHea: "PDRHea<sup>®</sup> – PilotD Recursive Hierarchic Scenario Generator",
    PlenRay: "PlenRay<sup>®</sup> Physical Ray Technology",
    softwareAndHardware:
      "Integrated Hardware/Software-in-the-Loop Testing System",
    DiL: "DiL Driver-in-the-Loop Solution",
    Medusa: "Medusa Whole-Vehicle High-Validity Simulation Platform",
    Hercules: "Hercules Cost-Effective Hardware-in-the-Loop Platform",
    // 生态圈
    matrix: "FrontFire Model Matrix",
    cooperation: "Ecosystems",
    fullscale: "Research and Development of Complex Intelligent Agent",
  },
  dialog: {
    title: "Message Board",
    content:
      "Thank you for your interest! For cooperation inquiries or other requests, please fill in your basic information below, and we will respond to you promptly. Alternatively, you may contact us directly at 021-69585189.",
    form: {
      name: "Name",
      namePlaceholder: "Please enter your name",
      nameIsRequired: "Name is required.",
      phone: "Phone",
      phonePlaceholder: "Please enter your contact number",
      phoneIsRequired: "Mobile number is required.",
      email: "Email",
      emailPlaceholder: "Please enter your email address",
      emailIsRequired: "Email address is required.",
      emailFormatError: "Invalid email address format.",
      company: "Company",
      companyPlaceholder: "Please enter your company name",
      companyIsRequired: "Company name is required.",
      success:
        "Thank you for your submission! We'll get back to you as soon as possible.",
    },
    care: "Areas of Interest",
    careTags: [
      "SiL Simulation Platform",
      "HiL Simulation Platform",
      "DiL Simulation Platform",
      "Traffic Flow Simulation",
      "Physical-Level Sensor Modeling",
      "Scenario Reconstruction",
      "Automated Scenario Generation",
      "",
    ],
    other: "Others",
    otherPlaceholder: "Please enter your message",
    submit: "SUBMIT NOW",
  },
};

export const headerCN = {
  menu: {
    home: "首页",
    product: "产品中心",
    ecosystem: "生态圈",
    about: "关于我们",
    join: "加入我们",
    contact: "联系我们",
    // 产品中心
    allIntelligence: "全境智能仿真测试验证软件体系",
    PDGaiA: "PDGaiA<sup>®</sup> 自动驾驶精准在环仿真测试平台",
    PDRobot: "PD 机器人虚拟开发验证解决方案",
    PDUranus: "PDUranus 智能无人低空载具虚拟优化平台",
    coreTechnology: "核心技术助力高效数据迭代",
    OnCloud: "On Cloud 精准仿真云计算平台",
    PDRHea: "PDRHea<sup>®</sup> 递归式分层场景生成器",
    PlenRay: "PlenRay<sup>®</sup> 物理射线技术",
    softwareAndHardware: "软硬件一体集成在环测试体系",
    DiL: "DiL 驾驶员在环解决方案",
    Medusa: "Medusa 高置信度仿真平台",
    Hercules: "Hercules 高性价比硬件在环仿真平台",
    // 生态圈
    matrix: "重器矩阵 模型共享平台",
    cooperation: "生态合作",
    fullscale: "全境智能研发",
  },
  dialog: {
    title: "留言板",
    content:
      "感谢您的关注，如需合作或有其他需求，可在下方填写基本信息，我们将尽快回复您！\n或者直接致电021-69585189与我们取得联系。",
    form: {
      name: "姓名",
      namePlaceholder: "请输入姓名",
      nameIsRequired: "姓名不能为空!",
      phone: "电话",
      phonePlaceholder: "请输入联系电话",
      phoneIsRequired: "手机号码不能为空!",
      email: "邮箱",
      emailPlaceholder: "请输入邮箱地址",
      emailIsRequired: "邮箱不能为空!",
      emailFormatError: "请输入合法的邮箱",
      company: "公司",
      companyPlaceholder: "请输入单位名称",
      companyIsRequired: "公司名称不能为空!",
      success: "您已提交成功，我们将尽快回复您！",
    },
    care: "您关注的内容",
    careTags: [
      "SiL仿真平台",
      "HiL仿真平台",
      "DiL仿真平台",
      "交通流仿真",
      "物理级传感器",
      "场景还原",
      "自动化场景搭建",
      "",
    ],
    other: "其他",
    otherPlaceholder: "请输入内容",
    submit: "立即提交",
  },
};
